import Rule from './Rule'

export default class Accepted extends Rule {
  get ruleName () {
    return 'accepted'
  }

  passes () {
    const truthy = [
      1,
      '1',
      'on',
      'On',
      'ON',
      'yes',
      'Yes',
      'YES',
      true,
      'true',
      'True',
      'TRUE'
    ]
    return truthy.includes(this.value)
  }
}
